export default {
	project_name: 'Uniglobo',
}
